import { useEffect, useState } from "react";
import axios from "axios";
import { APARTMENTS as LOCAL, VILLA_IMAGE } from "../data/apartments";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export function useApartments() {
  const [apartments, setApartments] = useState(LOCAL);

  useEffect(() => {
    axios
      .get(`${API}/apartments`)
      .then((res) => {
        setApartments(
          res.data.map((a) => {
            const local = LOCAL.find((l) => l.id === a.id) || {};
            return {
              ...a,
              image: a.image ? mediaUrl(a.image) : local.image || VILLA_IMAGE,
              gallery: a.gallery?.length ? a.gallery.map(mediaUrl) : local.gallery || [],
              it: a.description_it || local.it || "",
              en: a.description_en || local.en || "",
            };
          })
        );
      })
      .catch(() => {});
  }, []);

  return apartments;
}
